import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import './not-found.scss';

const NotFound: React.FC = () => {
	return (
		<div className="App not-found">
			<Helmet>
				<title>Página no encontrada - Connect Assistance</title>
				<meta name="robots" content="noindex" />
			</Helmet>
			<h1 className="title-green ctr">404</h1>
			<h2 className="ctr">Página no encontrada</h2>
			<p className="ctr">La página que buscas no existe o ya no está disponible.</p>
			<Link className="button" to="/">
				Volver al inicio
			</Link>
		</div>
	);
};

export default NotFound;
